import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Grid, Paper, TablePagination } from '@material-ui/core';
import axiosClient from '../../../http/axios-client';
import AppLoader from '../../basic/AppLoader';
import AppButtonMain from '../../basic/AppButtonMain';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  };
});

const MoreActions = (props) => {
  const { thematicPackage } = props;

  const queryClient = useQueryClient();

  const { data, isLoading, isFetching } = useQuery(
    [ 'product-details', thematicPackage.id ],
    () => { return axiosClient.get(`products/${ thematicPackage.id }`); },
    {
      refetchOnWindowFocus: false,
    },
  );

  const { mutate: publish, isLoading: publishing } = useMutation(
    [ 'publish-thematic-package', thematicPackage.id ],
    () => { return axiosClient.put('products/eshop-publish', { id: thematicPackage.id }); },
    {
      onSuccess() {
        queryClient.invalidateQueries([ 'product-details', thematicPackage.id ]);
      },
    },
  );

  const { mutate: unpublish, isLoading: unpublishing } = useMutation(
    [ 'unpublish-thematic-package', thematicPackage.id ],
    () => { return axiosClient.put('products/eshop-unpublish', { id: thematicPackage.id }); },
    {
      onSuccess() {
        queryClient.invalidateQueries([ 'product-details', thematicPackage.id ]);
      },
    },
  );

  if (isLoading || isFetching) { return <AppLoader />; }

  return (
    <>
      {
        'draft' === data?.status ? (
          <div>
            <Typography>
              This thematic package is currently
              {' '}
              <span style={ { fontWeight: 'bold' } }>NOT PUBLISHED</span>
              .
              <br />
              This means that the eshop customers are not currenlty able to see it.
              <br />
              Click &apos;publish&apos; so you can make the product active
            </Typography>
            <AppButtonMain
              text={ publishing ? 'Publishing ...' : 'Publish' }
              disabled={ publishing }
              onClick={ () => { return publish(); } }
            />
          </div>
        ) : (
          <div>
            <Typography>
              This thematic package is currently
              {' '}
              <span style={ { fontWeight: 'bold' } }>PUBLISHED</span>
              <br />
              This means that the eshop customers can see the product
              {' '}
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={ data?.permalink.replace('https', 'http') }
              >
                here
              </a>
              <br />
              Click &apos;unpublish&apos; if you want to hide the product from your customers
            </Typography>
            <AppButtonMain
              text={ unpublishing ? 'Unpublishing ...' : 'Unpublish' }
              disabled={ unpublishing }
              onClick={ () => { return unpublish(); } }
            />
          </div>
        )
      }
    </>
  );
};

const DeployedThematicPackages = (props) => {
  const { deployedThematicPackages } = props;
  const classes = useStyles();
  const [ expanded, setExpanded ] = React.useState(false);

  const {
    paginationProps: {
      page,
      limit,
      handleChangePage,
      handleChangeRowsPerPage,
      count,
    },
  } = props;
  const handleChange = (panel) => {
    return (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
  };
  // add header me tis sthles panw apo deployed packages
  return (
    <div className={ classes.root }>
      <Paper square>
        <Grid container>
          <Grid item xs={ 4 }>
            <Typography>Name</Typography>
          </Grid>
          <Grid item>
            <Typography>Description</Typography>
          </Grid>
        </Grid>
      </Paper>
      {
        deployedThematicPackages.map((dtp) => {
          return (
            <Accordion
              key={ dtp.id }
              expanded={ dtp.id === expanded }
              onChange={ handleChange(dtp.id) }
            >
              <AccordionSummary
                expandIcon={ <ExpandMoreIcon /> }
                aria-controls='panel1bh-content'
                id={ `header-${ dtp.id }` }
              >
                <Typography className={ classes.heading }>{dtp.name}</Typography>
                <Typography className={ classes.secondaryHeading }>{dtp.description}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <MoreActions thematicPackage={ dtp } />
              </AccordionDetails>
            </Accordion>
          );
        })
      }
      <TablePagination
        rowsPerPageOptions={ [ 5, 10, 25 ] }
        component='div'
        count={ count }
        page={ page }
        onChangePage={ handleChangePage }
        rowsPerPage={ limit }
        onChangeRowsPerPage={ handleChangeRowsPerPage }
      />
    </div>
  );
};
export default DeployedThematicPackages;
